module.exports = __webpack_public_path__ + "static/media/alcance.e9c28c5c.pdf";